import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import { indexRoute } from '@/pages/index/route';
import { loginRoute } from '@/pages/login/route';
import { reportsRoute } from '@/pages/reports/route';

// import { errorNotFoundRoute } from '@/pages/error/notFound/route';
// import { setTitleOnRouteChange } from '@/router/guards/setDocumentTitle';
// import { scrollBehavior } from '@/router/scrollBehavior';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  // Unauthenticated routes
  loginRoute,

  // Top-level links
  indexRoute,
  reportsRoute,

  // {
  //   path: '/',
  //   redirect: { name: indexRoute.name },
  // },

  // Error pages
  // errorNotFoundRoute,
];

const router = new VueRouter({
  routes,
  // scrollBehavior,
});

// router.beforeEach(setTitleOnRouteChange);

export default router;
